module.exports = __webpack_public_path__ + "img/agave.f1ce6443.svg";